import { FileAnswer } from '../common-caa/file-answer';

export class PreferencesSnapshotModel {
    availableImages: FileAnswer[] = [];
    constructor() {}
}
